import React, { useState } from "react";
import PropTypes from "prop-types";
import InputPassword from "components/InputPassword";
import useEnterKeyEvent from "hooks/useEnterKeyEvent";
import { Box } from "@mui/material";
import { checkPassWord } from "api/api_register2FA";
import Swal from "sweetalert2";
import avaImg from "assets/images/default-avt.jpg";
import "./Style.scss";

function Register2FARetypePassWord({
  setOpenIntroduce,
  setOpenReEnterPassword,
  setOpen2FAChooseType,
}) {
  const user = JSON.parse(localStorage.getItem("user"));
  const [password, setPassword] = useState({
    password: "",
    showPassword: false,
  });

  let dataReceive = {};
  const userName = user ? user.username : "";

  const handleLogin = async () => {
    if (userName) {
      dataReceive = await checkPassWord(userName, password.password);

      if (dataReceive) {
        setOpenReEnterPassword((prev) => !prev);
        setOpen2FAChooseType((prev) => !prev);
      } else {
        Swal.fire({
          icon: "error",
          title: "Sai mật khẩu",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    }
  };

  useEnterKeyEvent([userName, password], handleLogin);

  return (
    <Box width={480} className="form-container">
      <p className="fs-20 fw-700 gray-100">Xác thực 2 bước</p>
      <Box mt={2} className="d-flex w-50% h-30">
        <img className="profile-image" src={avaImg} alt="profile" style={{ borderRadius: "50%" }} />
      </Box>
      <Box mt={2} className="w-100 flex-column centered">
        <Box className="fs-14">{user.fullName} nhập lại mật khẩu xác thực</Box>
        <div style={{ marginTop: "3px" }} />
        <InputPassword
          className="w-100"
          placeholder="Nhập mật khẩu"
          value={password}
          onChange={setPassword}
        />
      </Box>
      <Box
        mt={3}
        sx={{
          display: "flex",
          justifyContent: "space-evenly",
          width: "75%",
        }}
      >
        <Box
          className="centered fs-14"
          style={{
            height: "36px",
            borderRadius: "6px",
            color: "var(--blue-blue-100)",
            border: "0.1px solid var(--blue-blue-100)",
            cursor: "pointer",
            width: "45%",
          }}
          role="button"
          tabIndex="0"
          onClick={() => {
            setOpenIntroduce((prev) => !prev);
            setOpenReEnterPassword((prev) => !prev);
          }}
          onKeyDown={() => {}}
        >
          Quay lại
        </Box>
        <Box
          className="centered fs-14"
          style={{
            height: "36px",
            background: "var(--blue-blue-100)",
            borderRadius: "6px",
            color: "white",
            cursor: "pointer",
            width: "45%",
          }}
          role="button"
          tabIndex="0"
          onClick={handleLogin}
          onKeyDown={() => {}}
        >
          Xác nhận
        </Box>
      </Box>
    </Box>
  );
}

Register2FARetypePassWord.defaultProps = {
  setOpenIntroduce: () => {},
  setOpenReEnterPassword: () => {},
  setOpen2FAChooseType: () => {},
};

Register2FARetypePassWord.propTypes = {
  setOpenIntroduce: PropTypes.func,
  setOpenReEnterPassword: PropTypes.func,
  setOpen2FAChooseType: PropTypes.func,
};

export default Register2FARetypePassWord;
